import { Component } from '@angular/core';
import { AttrPath, UitstroomtypeVSO } from '@cumlaude/metadata';
import { BasicFilterExpression, FilterExpression } from '../../services/data.service';
import { UitzonderingPrestatieanalyseComponent } from './uitzondering-prestatieanalyse.component';
import { BarchartTableComponent } from '../../shared/dashboard/barchart-table/barchart-table.component';
import { SchooljaarIndicatorOverComponent } from '../../schooljaar-indicator-over/schooljaar-indicator-over.component';
import { TooltipDirective } from '@cumlaude/shared-components-overlays';
import { DashboardHeaderComponent } from '../../dashboard-header/dashboard-header.component';
import { FilterPanelComponent } from '../../filter-panel/filter-panel.component';
import { DashboardContainerComponent } from '../../layout/dashboard-container/dashboard-container.component';
import { FilterBarComponent } from '../../filter-bar/filter-bar.component';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { FilterName } from '../../services/filter-name';

@Component({
	selector: 'app-uitzondering-uitstroomniveau',
	templateUrl: './uitzondering.component.html',
	styleUrls: ['./uitzondering.component.scss'],
	imports: [
		DashboardContainerComponent,
		FilterPanelComponent,
		DashboardHeaderComponent,
		TooltipDirective,
		SchooljaarIndicatorOverComponent,
		BarchartTableComponent,
		FilterBarComponent,
		IconComponent,
	],
})
export class UitzonderingUitstroomniveauComponent extends UitzonderingPrestatieanalyseComponent {
	groups: AttrPath[] = [
		['ds_nm_prestatieanalyse_vso_uitzondering'],
		['ds_fk_lb_van', 'lb_nm_uitstroomniveau_vso_status'],
		['ds_fk_ilt_van', 'ilt_nm_niveau'],
		['ds_nr_leerjaar_van'],
	];

	override overrideDefault?: Partial<{ [name in FilterName]: any }> = { ds_fun_nm_vergelijk_einduitstroomniveau_vso: [null] };

	initialFilters: FilterName[] = [
		'x_prestatieanalyse_ds_schooljaar',
		'ds_fk_br_vest_van.br_co_brin',
		'ds_fk_vs_van.vs_nm_vestiging',
		'ds_fk_ilt_van.ilt_nm_niveau',
		'ds_nr_leerjaar_van',
		'ds_nm_prestatieanalyse_vso_uitzondering',
		'ds_fk_ll.ll_des_uitschrijving',
		'ds_fk_lb_van.lb_nm_uitstroomniveau_vso_status',
		'ds_fun_nm_vergelijk_einduitstroomniveau_vso',
	];

	permanentFilterExpressions: FilterExpression[] = [
		// Bij VSO speelt 1 oktober geen rol, leerlingen stromen het hele jaar in en uit. We laten dus gegevens zien van de plaatsing waarin de leerling daadwerkelijk uitstroomt.
		new BasicFilterExpression(['ds_is_plaatsing_opeenvolgend'], 1),
		new BasicFilterExpression(['ds_nm_uitstroomtype_vso'], UitstroomtypeVSO.EINDUITSTROOM),
		new BasicFilterExpression(['ds_fk_br_vest_van', 'br_is_vso'], 1),
	];
}
